import { ProviderAccount } from '@prisma/client'
import { Flex, Form, Input } from 'antd'
import { useEffect } from 'react'
import { useUserContext } from '~/core/context'
import { ProviderClient } from '~/plugins/data-connector/providers/abstract/provider.client'
import { FormClient } from '~/plugins/form/client'

type Props = {
  account?: ProviderAccount
  provider?: ProviderClient
  onSubmit: (accountUpdated: ProviderAccount) => void
}

export const StepOne: React.FC<Props> = ({ account, provider, onSubmit }) => {
  const { session } = useUserContext()

  const FormInstance = FormClient.useForModel({
    modelName: 'ProviderAccount',
    keysToMerge: ['configuration'],
    onSuccess: onSubmit,
  })

  useEffect(() => {
    FormInstance.start({
      where: account ? { id: account.id } : undefined,
      values: provider
        ? { providerKey: provider.key, userId: session.user.id }
        : undefined,
    })
  }, [])

  return (
    <Flex vertical className="w-full">
      <FormInstance.FormView
        isModal={false}
        propsForm={{ buttonLabel: 'Submit' }}
      >
        <Form.Item
          label="Server name"
          name="name"
          rules={[{ required: true, message: 'Server name is required' }]}
        >
          <Input placeholder="Your server name" />
        </Form.Item>
        <Form.Item
          label="Server ID"
          name="configuration.serverId"
          rules={[{ required: true, message: 'Server ID is required' }]}
        >
          <Input placeholder="Your server ID" />
        </Form.Item>
      </FormInstance.FormView>
    </Flex>
  )
}
